import {
	createSortedRowModel,
	createTableHook,
	rowSortingFeature,
	sortFn_alphanumeric,
	sortFn_datetime,
	sortFn_text,
	tableFeatures,
} from "@tanstack/react-table";

// The single feature registration for every EMI table. Adding a feature here
// costs bundle size on every page with a table and turns the behaviour on
// everywhere at once, so it's a deliberate, product-wide decision rather than
// something an individual screen opts into quietly.
export const emiFeatures = tableFeatures({
	rowSortingFeature,
	sortedRowModel: createSortedRowModel(),
	sortFns: {
		alphanumeric: sortFn_alphanumeric,
		text: sortFn_text,
		datetime: sortFn_datetime,
	},
});

const emiTableHook = createTableHook({
	features: emiFeatures,
	getRowId: (row) => String(row.id),
});

export const useEmiTable = emiTableHook.useAppTable;
export const createEmiColumnHelper = emiTableHook.createAppColumnHelper;
export const useEmiTableContext = emiTableHook.useTableContext;

/**
 * A column definition bound to the EMI feature set. Use this JSDoc type on a
 * column array so editors surface the real TanStack shape (cell/header/meta)
 * without the project needing to become TypeScript.
 *
 * @template TData
 * @template [TValue=unknown]
 * @typedef {import('@tanstack/react-table').ColumnDef<typeof emiFeatures, TData, TValue>} EmiColumnDef
 */

/**
 * The row-data constraint every EMI table's `data` must satisfy.
 *
 * @typedef {import('@tanstack/react-table').RowData} EmiRowData
 */
